import { Fragment, useEffect } from 'react'
import { NextSeo } from 'next-seo'

import withPage from '@/lib/page/withPage'

import withServiceLayout from '@/features/Services/layouts/withServiceLayout'
import ServiceSection from '@/features/Services/templates/ServiceSection'
import PriceSection from '@/features/Services/templates/PriceSection'

import { WhatYouGet } from '@/components/Landing'

import { CCTV } from '@/features/Services/constants'
import { logEcommerce } from '@/lib/stats/gtm'

function CCTVPage() {
  useEffect(() => {
    logEcommerce('view_item', {
      items: [
        {
          item_id: 'CCTV Policy',
          item_name: 'CCTV Policy',
          quantity: 1,
          currency: 'THB',
        },
      ],
    })
  }, [])
  return (
    <Fragment>
      <NextSeo title="CCTV Policy" />

      <ServiceSection data={CCTV} />
      <PriceSection serviceName="CCTV" />
      <WhatYouGet hideDecor primaryColor={CCTV.PRIMARY_COLOR} />
    </Fragment>
  )
}

export default withPage()(withServiceLayout(CCTVPage))
